import type { ProductContentType, ProductType } from "@jipraks/shared";

export const catalogCopy = {
  productTypes: {
    course: "E-Course",
    ebook: "eBook",
    webinar: "Webinar",
    workflow: "Workflow",
    private: "Private",
  } satisfies Record<ProductType, string>,
  contentTypes: {
    video: "Video",
    pdf: "PDF",
    json: "Workflow JSON",
    text: "Teks",
    zip: "File ZIP",
    link: "Link",
  } satisfies Record<ProductContentType, string>,
  filterAll: "Semua",
  filterLabel: "Filter jenis produk",
  catalogEyebrow: "Katalog",
  catalogTitle: "Kelas, ebook & workflow",
  catalogDescription: "Materi praktis yang bisa langsung Anda terapkan di bisnis dan pekerjaan.",
  catalogEmpty: "Belum ada produk untuk kategori ini.",
  featuredEyebrow: "Paling direkomendasikan",
  featuredTitle: "Mulai dari sini",
  featuredDescription: "Pilihan kami untuk Anda yang ingin hasil paling cepat terasa.",
  featuredBadge: "Rekomendasi",
  purchased: (count: number) => `${count.toLocaleString("id-ID")}+ pembeli`,
  discount: (percent: number) => `Hemat ${percent}%`,
  viewDetail: "Lihat detail",
  loadError: "Gagal memuat data. Periksa koneksi Anda lalu coba lagi.",
  retry: "Coba lagi",
  detail: {
    breadcrumbHome: "Beranda",
    breadcrumbCatalog: "Katalog",
    benefitsTitle: "Yang Anda dapatkan",
    curriculumTitle: "Materi",
    curriculumCount: (count: number) => `${count} materi`,
    descriptionTitle: "Deskripsi",
    teaserLabel: "Tonton teaser",
    playTeaser: (title: string) => `Putar video teaser ${title}`,
    teaserFrameTitle: (title: string) => `Video teaser ${title}`,
    buyNow: "Beli sekarang",
    ownedBadge: "Sudah Anda miliki",
    openLibrary: "Buka materi",
    lifetimeAccess: "Akses seumur hidup · Bayar dengan QRIS atau Virtual Account",
    notFoundTitle: "Produk tidak ditemukan",
    notFoundDescription: "Produk ini mungkin sudah tidak tersedia.",
    backToCatalog: "Kembali ke katalog",
  },
} as const;
